var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKw({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512.001 512.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512 200.093H0V97.104a8.829 8.829 0 0 1 8.828-8.828h494.345a8.829 8.829 0 0 1 8.828 8.828L512 200.093z",
    fill: "#73af00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M503.172 423.725H8.828A8.829 8.829 0 0 1 0 414.897V311.909h512v102.988a8.828 8.828 0 0 1-8.828 8.828z",
    fill: "#ff4b55"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#f5f5f5",
    d: "M0 200.091h512v111.81H0z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.256 421.591l137.985-109.532-.003-112.12L3.256 90.411C1.311 92.03 0 94.376 0 97.104v317.793c0 2.729 1.311 5.075 3.256 6.694z",
    fill: "#464655"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKw);
export default __webpack_public_path__ + "static/media/kw.bbdb07871cf0fa17db8a307cf1bd2527.svg";
export { ForwardRef as ReactComponent };